import { expertiseApi } from '@/core/api/expertise'

export const {
  useGetExpertiseQuery,
  useCreateExpertiseMutation,
  useUpdateExpertiseMutation,
  useDeleteExpertiseMutation,
  useDiagnoseExpertiseMutation,
  useDraftExpertiseMutation,
  useSendExpertiseMutation,
  useCreateExpertiseDictaphoneMutation,
  useDeleteExpertiseDictaphoneMutation,
} = expertiseApi
